import styled from "@emotion/styled"
import type { ResponsiveImageView } from "@slfinrtl/ui-bff-routes"
import type { PictureProps } from "../picture/Picture"
import { Picture } from "../picture/Picture"
import { getRelevantImageVariants } from "./getRelevantImageVariants"
import type { PictureStaticSize } from "./getRelevantImageVariants"

export interface PictureStaticProps extends Partial<PictureProps> {
	className?: string
	picture?: ResponsiveImageView
	size: PictureStaticSize
}

export const PictureStatic = ({ aspectRatio = "4/3", picture, size, ...rest }: PictureStaticProps) => {
	const variants = getRelevantImageVariants(picture, size)

	return variants ? (
		<Picture aspectRatio={aspectRatio ?? picture?.aspectRatio} {...rest}>
			{/* for small images, avif is usually larger than webp */}
			{size >= 960 && variants.avif && <source type="image/avif" srcSet={variants.avif} />}
			{variants.webp && <source type="image/webp" srcSet={variants.webp} />}
			{variants.jpeg && <source type="image/jpeg" srcSet={variants.jpeg} />}
		</Picture>
	) : (
		<Placeholder aspectRatio={aspectRatio} alt="Placeholder" {...rest} />
	)
}

const Placeholder = styled(Picture)`
	text-indent: 100%;
	white-space: nowrap;
`
